import { render } from "./MessageListItem.vue?vue&type=template&id=6454e584"
import script from "./MessageListItem.vue?vue&type=script&lang=js"
export * from "./MessageListItem.vue?vue&type=script&lang=js"

import "./MessageListItem.vue?vue&type=style&index=0&id=6454e584&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__